import users from '../users'   
import items_store from '../items'   
import DATA from '../../plugins/DATA' 
import DB from '../../plugins/DB'  
import WORKER from 'simple-web-worker'
import  { 
  toDateTime, 
  toDate,
  toTime,
  TEXT_UP,
  TEXT_UP1,
  TEXT_UP11,
  TEXT_UP0,
  TEXT_EQ,
  TEXT_SPLIT_N,
  TEXT_SPACE0, 
  DEFINED_ONLY,
  SIZE
} from '../../plugins/MBS_actions' 
import formatNumber  from '../../plugins/formatNumber'   
import moment from 'moment'      
const toNumber=formatNumber.toNumber
const toMoney=formatNumber.toMoney
const toSameLength=formatNumber.toSameLength
  
let NAME = "STORE-LOCALS"

export default{
    state: {  
      LOCAL_DEVICES:null,  
      LOCAL_DAYS_SHIFTS:null, 
      LOCAL_CASHUPS:null, 
      LOCAL_SALE_ORDERS:null, 
      LOCAL_ITEM_ORDERS:null, 
      LOCAL_SELECTED_ITEMS:null, 
      LOCAL_SELECTED_SALES_ITEMS:null, 
      LOCAL_SELECTED_WAREHOUSE_ITEMS:null, 
      LOCAL_STOCK_TAKING_ITEMS:null,  
      LOCAL_SELECTED_STOCK_ADJUSTMENTS:null,  
      LOCAL_EXPENSES:null,  

      LOCAL_QUOTATIONS:null, 
      LOCAL_JOINED_STOCK_TAKINGS:null,  
      LOCAL_WAREHOUSE_SESSIONS:null,  
      LOCAL_WAREHOUSE_ORDERS:null,

      UPDATE_DAY_SHIFT_LOADING:false,   
      UPDATE_DAY_SHIFT_WAITING:false,   
      UPDATE_CASHUP_LOADING:false,   
      UPDATE_CASHUP_WAITING:false,   
      UPDATE_ITEM_ORDERS_LOADING:false,   
      UPDATE_ITEM_ORDERS_WAITING:false, 
      UPDATE_STOCK_TAKING_ITEMS_LOADING:false,   
      UPDATE_STOCK_TAKING_ITEMS_WAITING:false, 
      UPDATE_EXPENSES_LOADING:false,   
      UPDATE_EXPENSES_WAITING:false, 
       
    },
    //___________________-GETTERS-_________________
    getters: {  
      get(state) { 
        return state
      },
      getLocalCashups(state) { 
        return state.LOCAL_CASHUPS
      },  
      getLocalCashup(state) { 
        const cashups = state.LOCAL_CASHUPS
        const cashup = cashups?cashups.find(item=>{
          return !item.closed
        }):null 
        return cashup
      }, 
      getCurrentOutlet(state) { 
        const cashups = state.LOCAL_CASHUPS
        const cashup = cashups?cashups.find(item=>{
          return !item.closed
        }):null 
        const outlet_code = cashup?.outlet_code
        const outlet = items_store.getters.getStockOutletByCode(outlet_code)
        return outlet
      },   
    },
    //___________________-MUTATIONS-___________________
    mutations:{  
      setLocals(state, payload) {
        try {
          let name = payload?payload.name:null
          let data = payload?payload.data:null 
          state[name]=data  
        } catch (error) {
          console.log(error,'error.....');
        }
      }, 
    },
    //____________________[ACTIONS]_____________________
    actions: {   
      initiate_locals({ commit,state}, payload) {
        let response = {
          from:'initiate_locals',
          page:NAME, 
          payload:payload
        }
        return new Promise(async (resolve,reject)=>{
          try {
            let names = payload?payload.names:null  
            
            if (!names) {
              names=[
                DATA.ITEMS.LOCAL_DEVICES.values,
                DATA.ITEMS.LOCAL_DAYS_SHIFTS.values,
                DATA.ITEMS.LOCAL_CASHUPS.values,
                DATA.ITEMS.LOCAL_SALE_ORDERS.values,
                DATA.ITEMS.LOCAL_ITEM_ORDERS.values,
                DATA.ITEMS.LOCAL_SELECTED_ITEMS.values,
                DATA.ITEMS.LOCAL_SELECTED_SALES_ITEMS.values,
                DATA.ITEMS.LOCAL_SELECTED_WAREHOUSE_ITEMS.values,
                DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values,
                DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.values,
                DATA.ITEMS.LOCAL_QUOTATIONS.values,
                DATA.ITEMS.LOCAL_EXPENSES.values,
              ]
            }
            let names_data=[]
            if (names) {
              for (const name of names) {
                let db_res = await DB.getItems({
                  name:name
                })
                let data = db_res?db_res.data:null 
                names_data.push({
                  name:name,
                  data:data
                })
                commit("setLocals",{
                  name:TEXT_UP(name),
                  data:data,
                })  
              } 
            } 
            resolve({
              success:true,
              names_data:names_data
            }) 
          } catch (error) {
            response = {
              ...response,
              error:{
                error:error,
                data:payload
              }, 
            }
            commit("ERROR",response)
            reject(response)
          } 
        })
      }, 
      initiate_company_locals({ commit,state}, payload) {
        let response = {
          from:'initiate_company_locals',
          page:NAME, 
          payload:payload
        }
        return new Promise(async (resolve,reject)=>{
          try {
            let names = payload?payload.names:null  
            let company_key = payload?payload.company_key:null  
 
            if (!names) {
              names=[
                // DATA.ITEMS.LOCAL_DAYS_SHIFTS.values,
                // DATA.ITEMS.LOCAL_CASHUPS.values,
                // DATA.ITEMS.LOCAL_ITEM_ORDERS.values,
                // DATA.ITEMS.LOCAL_QUOTATIONS.values, 
              ]
            }
            let names_data=[]
            if (names&&company_key) {
              for (const name of names) {
                let db_res = await DB.getItems({
                  name:name,
                  company_key:company_key,
                })
                let data = db_res?db_res.data:null 
                names_data.push({
                  name:name,
                  data:data,
                  company_key:company_key,
                }) 
                commit("setLocals",{
                  name:TEXT_UP(name),
                  data:data,
                })  
              } 
            } 
            resolve({
              success:true,
              names_data:names_data
            }) 
          } catch (error) {
            response = {
              ...response,
              error:{
                error:error,
                data:payload
              }, 
            }
            commit("ERROR",response)
            reject(response)
          } 
        })
      }, 
      on_update_locals({ commit,dispatch}, payload) {
        let response = {
          from:'on_update_locals',
          page:NAME, 
          payload:payload
        }
        return new Promise(async (resolve,reject)=>{
          try { 
            let name = payload?payload.name:null
            let data = payload?payload.data:null
            let data_after = payload?payload.data_after:null
            let company_key = payload?payload.company_key:null  
            let prevent_upload = payload?payload.prevent_upload:null  
            commit("setLocals",{
              name:TEXT_UP(name),
              data:data_after,
              company_key:company_key,
            }) 
            let res = null
            let resWithError = null 
            try {
              if (!prevent_upload) {
                res = await dispatch("upload_locals",{
                  name:name,
                  names:[{value:name,data:data_after}], 
                  company_key:company_key,
                })   
              }
              // console.log(res,'on_update_locals..........ss');
            } catch (error) {
              resWithError = error
              console.log(error,'on_update_locals..........ee');
            }
 
            if (resWithError) {
              resolve({
                success:false,
                res:res,
                errors:resWithError,
                error:"finish with error",
              }) 
            } else {
              resolve({
                success:true,
                res:res
              })  
            }
          } catch (error) {
            response = {
              ...response,
              error:{
                error:error,
                data:payload
              }, 
            }
            commit("ERROR",response)
            reject(response)
          } 
        })
      }, 
      upload_locals({ commit,dispatch}, payload) {
        let response = {
          from:'upload_locals',
          page:NAME, 
          payload:payload
        }
        return new Promise(async (resolve,reject)=>{
          try { 
            let names = payload?payload.names:null 
            if(!names){
              names = [
                {value:DATA.ITEMS.LOCAL_DAYS_SHIFTS.values},
                {value:DATA.ITEMS.LOCAL_CASHUPS.values},
                {value:DATA.ITEMS.QUOTATIONS.value},
                {value:DATA.ITEMS.LOCAL_ITEM_ORDERS.value},
                {value:DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.value},
              ]
            }
            let successes = []
            let submit_errors = false
            let errors = []  
            for (const name of names) {
              try {
                let res = {}
                if (name.value == DATA.ITEMS.LOCAL_DAYS_SHIFTS.values) {
                  res = await dispatch("fi_upload_day_shifts",{
                    data:name.data 
                  })  
                }else if (name.value == DATA.ITEMS.LOCAL_CASHUPS.values) {
                  res = await dispatch("fi_upload_cashups",{
                    data:name.data 
                  })  
                }else if (name.value == DATA.ITEMS.LOCAL_QUOTATIONS.values) {
                  res = await dispatch("fi_upload_quotations",{
                    data:name.data 
                  })  
                }else if (name.value == DATA.ITEMS.QUOTATIONS.values) {
                  res = await dispatch("fi_upload_quotations",{
                    data:name.data 
                  })  
                }else if (name.value == DATA.ITEMS.LOCAL_ITEM_ORDERS.values) {
                  res = await dispatch("fi_upload_item_orders",{
                    data:name.data 
                  })  
                }else if (name.value == DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.values) {
                  res = await dispatch("fi_upload_stock_take_items",{
                    data:name.data 
                  })  
                }else if (name.value == DATA.ITEMS.LOCAL_EXPENSES.values) {
                  res = await dispatch("fi_upload_expenses",{
                    data:name.data 
                  })  
                }else{
                  res = {error:'no name'}
                } 
                successes.push({
                  name:name,
                  res:res
                })
              } catch (error) {
                errors.push({
                  name:name,
                  error:error
                })
                submit_errors = true
              }
            } 
            if (submit_errors) {
              reject({
                error:"finish with error",
                errors:errors,
                successes:successes, 
              })
            } else {
              resolve({
                success:true,
                errors:errors,
                successes:successes, 
              })
            } 
             
          } catch (error) {
            response = {
              ...response,
              error:{
                error:error,
                data:payload
              }, 
            }
            commit("ERROR",response)
            reject(response)
          } 
        })
      }, 

      //-----FI UPLOAD
      fi_upload_day_shifts({ commit,dispatch,state}, payload) {
        return new Promise(async (resolve,reject)=>{
          let response = {
            from:'fi_upload_day_shifts',
            page:NAME, 
            payload:payload
          }
          try { 
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'uploading/day_shifts' 
            })  
 
            //initiate
            let data = payload?payload.data:null    
            if (state.UPDATE_DAY_SHIFT_LOADING) {
              state.UPDATE_DAY_SHIFT_WAITING = true
            } else {
              let submit_errors = false
              let uploaded_already = []
              let uploaded_items = []
              let successes = []
              let errors = []
              if (!data) {
                let res = await  DB.getItems({name:DATA.ITEMS.LOCAL_DAYS_SHIFTS.values})
                data = res?res.data:null 
                if (!data) {
                  resolve({
                    error:"no data"
                  })
                  return
                } 
              }  
              for (const item of data) {
                const order = DEFINED_ONLY({...item,uploaded:true})
                const order_key = item.key
                const company_key = item.company_key
                const created_uid = item.created_uid
  
                if (item.uploaded) {
                  uploaded_already.push(item)
                } else {
                  let path = await dispatch("company_link",{
                    link:DATA.PATHS.days_shifts+order_key,
                    company_key:company_key
                  }) 
                  if (order_key && path && company_key) {
                    try {
                      let upRes = await dispatch('fi_update',{
                        action:DATA.ITEMS.DAYS_SHIFTS.values,
                        data:order,
                        path:path,
                        uid:created_uid,
                      })  
     
                      //-------UPDATE LOCALS AFTER UPLOAD 
                      await DB.deleteItems({
                        key:order_key,
                        name:DATA.ITEMS.LOCAL_DAYS_SHIFTS.values,
                        update_locals:true
                      }) 
                     
                      successes.push(upRes)
                      uploaded_items.push(item)
                    } catch (error) {
                      errors.push(error)
                      submit_errors = true
                    }
                  }else{
                    submit_errors = true
                    errors.push({
                      item:item,
                      error:"payload required"
                    })
                  }   
                } 
              } 
              state.UPDATE_DAY_SHIFT_LOADING = false
              if (state.UPDATE_DAY_SHIFT_WAITING) {
                state.UPDATE_DAY_SHIFT_WAITING = false
                dispatch('fi_upload_day_shifts')
              } 

              
              if (submit_errors) {
                reject({
                  error:"finish with error",
                  errors:errors,
                  successes:successes,
                  uploaded_items:uploaded_items,
                  uploaded_already:uploaded_already
                })
              } else {
                resolve({
                  success:true,
                  errors:errors,
                  successes:successes,
                  uploaded_items:uploaded_items,
                  uploaded_already:uploaded_already
                })
              }  
              commit('updateLoading', false)  
            }  
          } catch (error) {
            commit('updateLoading', false)
            response = {
              ...response,
              error:error
            }
            commit("ERROR",response)
            reject(response)
          }
        })
      }, 
      fi_upload_cashups({ commit,dispatch,state}, payload) {
        return new Promise(async (resolve,reject)=>{
          let response = {
            from:'fi_upload_cashups',
            page:NAME, 
            payload:payload
          }
          try { 
             
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'uploading/cashups' 
            })  

            //initiate
            let data = payload?payload.data:null    
            if (state.UPDATE_CASHUP_LOADING) {
              state.UPDATE_CASHUP_WAITING = true
            } else {
              let submit_errors = false
              let uploaded_already = []
              let uploaded_items = []
              let successes = []
              let errors = []
              if (!data) {
                let res = await  DB.getItems({name:DATA.ITEMS.LOCAL_CASHUPS.values})
                data = res?res.data:null 
                if (!data) {
                  resolve({
                    error:"no data"
                  })
                  return
                } 
              } 
              for (const cashup of data) {
                const order = DEFINED_ONLY({...cashup,uploaded:true})
                const cashup_key = cashup.key
                const day_shift_key = cashup.day_shift_key
                const company_key = cashup.company_key
                const created_uid = cashup.created_uid
  
                if (cashup.uploaded) {
                  uploaded_already.push(cashup)
                  if (cashup.close_at) {
                    await DB.addItems({
                      name:DATA.ITEMS.LOCAL_CASHUPS.values,
                      data:{...cashup,uploaded:false},
                      update_locals:true
                    }) 
                  }
                } else {
                  let path = await dispatch("company_link",{
                    link:DATA.PATHS.days_shifts+day_shift_key+"/cashups/"+cashup_key,
                    company_key:company_key
                  }) 
                  if (cashup_key && day_shift_key && path && company_key) {
                    try {
                      let upRes = await dispatch('fi_update',{
                        action:DATA.ITEMS.CASHUPS.values,
                        data:order,
                        path:path,
                        uid:created_uid,
                      })  
    
                      //-------UPDATE LOCALS AFTER UPLOAD  
                      if (cashup.close_at) { 
                        await DB.deleteItems({
                          key:cashup_key,
                          name:DATA.ITEMS.LOCAL_CASHUPS.values,
                        })   
                      }else{ 
                        await DB.addItems({
                          name:DATA.ITEMS.LOCAL_CASHUPS.values,
                          data:{...cashup,uploaded:true}
                        }) 
                      }
                     
                      successes.push(upRes)
                      uploaded_items.push(cashup)
                    } catch (error) {
                      errors.push(error)
                      submit_errors = true
                    }
                  }else{
                    submit_errors = true
                    errors.push({
                      cashup:cashup,
                      error:"payload required"
                    })
                  }   
                } 
              } 
              state.UPDATE_CASHUP_LOADING = false
              if (state.UPDATE_CASHUP_WAITING) {
                state.UPDATE_CASHUP_WAITING = false
                dispatch('fi_upload_cashups')
              } 

              
              if (submit_errors) {
                reject({
                  error:"finish with error",
                  errors:errors,
                  successes:successes,
                  uploaded_items:uploaded_items,
                  uploaded_already:uploaded_already
                })
              } else {
                resolve({
                  success:true,
                  errors:errors,
                  successes:successes,
                  uploaded_items:uploaded_items,
                  uploaded_already:uploaded_already
                })
              }  
              commit('updateLoading', false)  
            }  
          } catch (error) {
            commit('updateLoading', false)
            response = {
              ...response,
              error:error
            }
            commit("ERROR",response)
            reject(response)
          }
        })
      }, 
      fi_upload_quotations({ commit,dispatch}, payload) {
        return new Promise(async (resolve,reject)=>{
          let response = {
            from:'fi_upload_quotations',
            page:NAME, 
            payload:payload
          }
          try { 
             
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'uploading/quotation' 
            })  
            //initiate
            let data = payload?payload.data:null  
            
            let submit_errors = false
            let uploaded_already = []
            let uploaded_items = []
            let successes = []
            let errors = []
            if (!data) {
              let res = await  DB.getItems({name:DATA.ITEMS.LOCAL_QUOTATIONS.values})
              data = res?res.data:null 
              if (!data) {
                resolve({
                  error:"no data"
                })
                return
              } 
            }
            for (const item of data) {
              let key = item.key
              let day_shift_key = item.day_shift_key
              let company_key = item.company_key
              let uid = item.uid

              if (item.uploaded) {
                uploaded_already.push(item)
              } else {
                let path = await dispatch("company_link",{
                  link:DATA.PATHS.issued_quotations+day_shift_key+"/"+key,
                  company_key:company_key
                }) 
                if (key && path && company_key) {
                  try {
                    let upRes = await dispatch('fi_update',{
                      action:DATA.ITEMS.QUOTATIONS.values,
                      data:DEFINED_ONLY({...item,uploaded:true}),
                      uid:uid,
                      path:path,
                    })  
  
                    //-------UPDATE LOCALS AFTER UPLOAD 
                    DB.addItems({
                      name:DATA.ITEMS.LOCAL_QUOTATIONS.values,
                      data:{...item,uploaded:true}
                    }) 
                    successes.push(upRes)
                    uploaded_items.push(item)
                  } catch (error) {
                    errors.push(error)
                    submit_errors = true
                  }
                }else{
                  submit_errors = true
                  errors.push({
                    item:item,
                    error:"payload required"
                  })
                }   
              }

            }  
            // await dispatch("initiate_locals",{
            //   names:[DATA.ITEMS.LOCAL_QUOTATIONS.values], 
            // }) 
 

            if (submit_errors) {
              reject({
                error:"finish with error",
                errors:errors,
                successes:successes,
                uploaded_items:uploaded_items,
                uploaded_already:uploaded_already
              })
            } else {
              resolve({
                success:true,
                errors:errors,
                successes:successes,
                uploaded_items:uploaded_items,
                uploaded_already:uploaded_already
              })
            }  
            commit('updateLoading', false) 
          } catch (error) {
            commit('updateLoading', false)
            response = {
              ...response,
              error:error
            }
            commit("ERROR",response)
            reject(response)
          }
        })
      }, 
      fi_upload_item_orders({ commit,dispatch,state}, payload) {
        return new Promise(async (resolve,reject)=>{
          let response = {
            from:'fi_upload_item_orders',
            page:NAME, 
            payload:payload
          }
          try { 
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'uploading/item_orders' 
            })  
 
            //initiate
            let data = payload?payload.data:null    
            if (state.UPDATE_ITEM_ORDERS_LOADING) {
              state.UPDATE_ITEM_ORDERS_WAITING = true
            } else {
              let submit_errors = false
              let uploaded_already = []
              let uploaded_items = []
              let successes = []
              let errors = []
              if (!data) {
                let res = await  DB.getItems({name:DATA.ITEMS.LOCAL_ITEM_ORDERS.values})
                data = res?res.data:null 
                if (!data) {
                  resolve({
                    error:"no data"
                  })
                  return
                } 
              }  
              console.log(data,'fi_upload_item_orders----------ii-');
              let upload_data = []
              for (const item of data) {
                const order = DEFINED_ONLY({...item,uploaded:true})
                const order_key = item.key
                const day_shift_key = order.day_shift_key
                const company_key = item.company_key
                const created_uid = item.created_uid
  
                if (item.uploaded) {
                  uploaded_already.push(item)
                } else {
                  let path = await dispatch("company_link",{
                    link:DATA.PATHS.item_orders+day_shift_key+"/"+order_key,
                    company_key:company_key
                  }) 
                  if (order_key && path && company_key) {
                    //check item
                    let uploading_item = {}
                    if (item.joined_items) {
                      uploading_item = {
                        calculated_vat: item.calculated_vat,
                        cashup_key:item.cashup_key,
                        company_key:item.company_key,
                        created_uid:item.created_uid,
                        customer_key:item.customer_key,
                        day_shift_key:item.day_shift_key,
                        items:item.items,
                        key:item.key,
                        local_created_at:item.local_created_at,
                        order_option:item.order_option,
                        order_option_key:item.order_option_key,
                        order_type:item.order_type,
                        outlet_code:item.outlet_code,
                        path:item.path,
                        sum_amount:item.sum_amount,
                        table_key:item.table_key,
                        take_away:item.take_away,
                        till_code:item.till_code,
                        total_discount:item.total_discount,
                        total_price:item.total_price,
                        uploaded:item.total_price,
                        waiter_key:item.waiter_key,
                      }
                    } else {
                      uploading_item = item
                    }
                    upload_data.push({...uploading_item,path:path,uploaded:true})
                     
                  }   
                } 
              } 
              console.log(upload_data,'upload_data...........');
              let upload_res = await dispatch('fi_update',{
                action:DATA.ITEMS.ITEM_ORDERS.values,
                data:upload_data, 
                multiple:true, 
              })  

              //-------UPDATE LOCALS AFTER UPLOAD 
              let local_update_res = await DB.updateItems({
                name:DATA.ITEMS.LOCAL_ITEM_ORDERS.values,
                data:upload_data,
                update_locals:true,
                prevent_upload:true
              }) 

              
              console.log(upload_res,'upload_res...........');
              console.log(local_update_res,'local_update_res...........');

              state.UPDATE_ITEM_ORDERS_LOADING = false
              if (state.UPDATE_ITEM_ORDERS_WAITING) {
                state.UPDATE_ITEM_ORDERS_WAITING = false
                dispatch('fi_upload_item_orders')
              } 

              resolve({
                success:true,
                upload_res:upload_res,
                local_update_res:local_update_res,
                uploaded_items:uploaded_items,
                uploaded_already:uploaded_already
              })
              commit('updateLoading', false)  
            }  
          } catch (error) {
            commit('updateLoading', false)
            response = {
              ...response,
              error:error
            }
            commit("ERROR",response)
            reject(response)
          }
        })
      }, 
      fi_upload_stock_take_items({ commit,dispatch,state}, payload) {
        return new Promise(async (resolve,reject)=>{
          let response = {
            from:'fi_upload_stock_take_items',
            page:NAME, 
            payload:payload
          }
          try { 
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'uploading/stock_take_items' 
            })  
 
            //initiate
            let data = payload?payload.data:null    
            if (state.UPDATE_STOCK_TAKING_ITEMS_LOADING) {
              state.UPDATE_STOCK_TAKING_ITEMS_WAITING= true
            } else {
              let submit_errors = false
              let uploaded_already = []
              let uploaded_items = []
              let successes = []
              let errors = []
              if (!data) {
                let res = await  DB.getItems({name:DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.values})
                data = res?res.data:null 
                if (!data) {
                  resolve({
                    error:"no data"
                  })
                  return
                } 
              }  
              const upload_data = data?.filter(item=>!item.uploaded&&!item.loading)
              if (!SIZE(upload_data)) {
                resolve({
                  success:false, error:"no data",
                  data,upload_data
                })
                commit('updateLoading', false)  
                console.log(data,upload_data,'no data-----!');
                
                return
              }
              let upload_data_items = []
              let upload_data_stock = []
              let upload_data_local_uploaded = []
              let upload_data_local_loading = []
              for (const item of upload_data) {
                const order = DEFINED_ONLY({...item,uploaded:true})  
                const key = order.key
                const item_key = order.item_key
                const code = order.code
                const item_code = order.item_code
                const name = order.name
                const stock_taking_key = order.stock_taking_key
                const stock_taking_outlet_code = order.stock_taking_outlet_code
                const counted_stocks = order.counted_stocks
                const new_counted_stocks = order.new_counted_stocks
                const company_key = order.company_key 
                const local_created_at = order.local_created_at 
                const local_updated_at = order.local_updated_at 
                const uploaded = item.uploaded 
                const link = DATA.PATHS.stock_taking_items+stock_taking_key+"/"+item_key

                
                if (!uploaded&&company_key&&item_key&&new_counted_stocks) {
                  const path = await dispatch("company_link",{
                    link:link,
                    company_key:company_key
                  }) 
                  upload_data_local_loading.push({key,loading:true})
                  upload_data_local_uploaded.push({key,loading:false,uploaded:true})
                  if (!counted_stocks) {
                    let counted_stocks = {}
                    new_counted_stocks.forEach(stock => {
                      counted_stocks[stock.key]=stock 
                    });
                    upload_data_items.push({
                      path:path,
                      key,item_key,code,item_code,name,
                      stock_taking_outlet_code,
                      company_key,
                      stock_taking_key,
                      uploaded:true,
                      counted_stocks, local_created_at, local_updated_at
                    })
                  }else if (new_counted_stocks) {
                    const stock_path = path+"/counted_stocks"
                    new_counted_stocks.forEach(stock => {
                      upload_data_stock.push({
                        path:stock_path,
                        item_key,
                        ...stock
                      })
                      
                    });
                  } 
                }else{
                  console.log(order,'order no data.............'); 
                } 
              } 

              let upload_item_res = null
              let upload_stock_res = null
              let local_loading_update_res = null
              let local_uploaded_update_res = null
              if (SIZE(upload_data_local_loading)) {
                local_loading_update_res = await DB.updateItems({
                  name:DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.values,
                  data:upload_data_local_loading,
                  update_locals:true,
                  prevent_upload:true
                })  
                
              }
              if (SIZE(upload_data_items)) {
                upload_item_res = await dispatch('fi_update',{
                  action:DATA.ITEMS.STOCK_TAKING_ITEMS.values,
                  data:upload_data_items, 
                  multiple:true, 
                })  
              }
              if (SIZE(upload_data_stock)) {
                upload_stock_res = await dispatch('fi_add',{
                  action:DATA.ITEMS.STOCK_TAKING_ITEMS.values,
                  data:upload_data_stock, 
                  multiple:true, 
                })   
              }
              if (SIZE(upload_data_local_uploaded)) {
                local_uploaded_update_res = await DB.updateItems({
                  name:DATA.ITEMS.LOCAL_STOCK_TAKING_ITEMS.values,
                  data:upload_data_local_uploaded,
                  update_locals:true,
                  prevent_upload:true
                })  
                
              }
              
              
              state.UPDATE_STOCK_TAKING_ITEMS_LOADING = false
              if (state.UPDATE_STOCK_TAKING_ITEMS_WAITING) {
                state.UPDATE_STOCK_TAKING_ITEMS_WAITING = false
                dispatch('fi_upload_item_orders')
              } 

              resolve({
                success:true,
                upload_data_local_loading,upload_data_items,upload_data_stock,upload_data_local_uploaded,
                upload_item_res:upload_item_res,
                upload_stock_res:upload_stock_res,
                local_uploaded_update_res:local_uploaded_update_res,
                local_loading_update_res:local_loading_update_res,
                uploaded_items:uploaded_items,
                uploaded_already:uploaded_already
              })
              commit('updateLoading', false)  
            }  
          } catch (error) {
            commit('updateLoading', false)
            response = {
              ...response,
              error:error
            }
            commit("ERROR",response)
            reject(response)
          }
        })
      }, 
      fi_upload_expenses({ commit,dispatch,state}, payload) {
        return new Promise(async (resolve,reject)=>{
          let response = {
            from:'fi_upload_expenses',
            page:NAME, 
            payload:payload
          }
          try { 
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'uploading/item_orders' 
            })  
 
            //initiate
            let data = payload?payload.data:null    
            if (state.UPDATE_EXPENSES_LOADING) {
              state.UPDATE_EXPENSES_WAITING = true
            } else {
              let submit_errors = false
              let uploaded_already = []
              let uploaded_items = []
              let successes = []
              let errors = []
              if (!data) {
                let res = await  DB.getItems({name:DATA.ITEMS.LOCAL_EXPENSES.values})
                data = res?res.data:null 
                if (!data) {
                  resolve({
                    error:"no data"
                  })
                  return
                } 
              }  
              console.log(data,'fi_upload_expenses----------ii-');
              let upload_data = []
              for (const item of data) {
                const order = DEFINED_ONLY({...item,uploaded:true})
                const order_key = item.key 
                const company_key = item.company_key 
  
                if (item.uploaded) {
                  uploaded_already.push(item)
                } else {
                  let path = await dispatch("company_link",{
                    link:DATA.PATHS.expenses+order_key,
                    company_key:company_key
                  }) 
                  console.log(path,',------------xx');
                  
                  if (order_key && path) {
                    //check item 
                    upload_data.push({...order,path:path,uploaded:true})
                     
                  }   
                } 
              } 
              console.log(upload_data,'upload_data...........');
              let upload_res = await dispatch('fi_update',{
                action:DATA.ITEMS.EXPENSES.values,
                data:upload_data, 
                multiple:true, 
              })  

              //-------UPDATE LOCALS AFTER UPLOAD 
              let local_update_res = await DB.updateItems({
                name:DATA.ITEMS.LOCAL_EXPENSES.values,
                data:upload_data,
                update_locals:true,
                prevent_upload:true
              }) 

              
              console.log(upload_res,'upload_res...........');
              console.log(local_update_res,'local_update_res...........');

              state.UPDATE_EXPENSES_LOADING = false
              if (state.UPDATE_EXPENSES_WAITING) {
                state.UPDATE_EXPENSES_WAITING = false
                dispatch('fi_upload_item_orders')
              } 

              resolve({
                success:true,
                upload_res:upload_res,
                local_update_res:local_update_res,
                uploaded_items:uploaded_items,
                uploaded_already:uploaded_already
              })
              commit('updateLoading', false)  
            }  
          } catch (error) {
            commit('updateLoading', false)
            response = {
              ...response,
              error:error
            }
            commit("ERROR",response)
            reject(response)
          }
        })
      }, 


      //-----------------------[LOCAL SELECTED SALES ]---------
     


      add_local_item({ commit,state}, payload) {
        try {
          let key = payload.key
          let value_item = payload.value_item
          let data = payload.data 
          let items = []
 
          
          if (!key) {
            commit("ERROR",{
              error:{
                error:'No key',
                data:payload
              },
              from:'add_local_item',
              page:NAME, 
            })
            return
          }if (!value_item) {
            commit("ERROR",{
              error:{
                error:'no value',
                data:payload
              },
              from:'add_local_item',
              page:NAME, 
            })
            return
          }if (!data) {
            commit("ERROR",{
              error:{
                error:'no data',
                data:payload
              },
              from:'add_local_item',
              page:NAME, 
            })
            return
          } 
          value_item = value_item.toUpperCase()

          if (value_item==='PROVINCES'||value_item==='PROVINCE') {
            items = [...state.PROVINCES]
          }else if(value_item==='DISTRICTS'||value_item==='DISTRICT') {
            items = [...state.DISTRICTS]
          }else if(value_item==='CONSTITUENCIES'||value_item==='CONSTITUENCY') {
            items = [...state.CONSTITUENCIES]
          }else if(value_item==='POLLING_STATIONS'||value_item==='POLLING_STATION') {
            items = [...state.POLLING_STATIONS]
          }else if(value_item==='REPORTS'||value_item==='REPORT') {
            items = [...state.REPORTS]
          }else if(value_item==='SMS'||value_item==='sms') {
            items = [...state.SMS]
          }else if(value_item==='REPORT_CATEGORIES'||value_item==='REPORT_CATEGORY') {
            items = [...state.REPORT_CATEGORIES]
          }else if(value_item==='POLLS'||value_item==='POLL') {
            items = [...state.POLLS]
          }else if(value_item==='NEWS'||value_item==='NEWS') {
            items = [...state.NEWS]
          } 

          let item_size = items?items.length:0
          if (item_size===0) { 
             item = []
          }

          items.push({
            key:key,
            ...data
          })

          if (value_item==='PROVINCES'||value_item==='PROVINCE') {
            state.PROVINCES=items 
          }else if(value_item==='DISTRICTS'||value_item==='DISTRICT') {
            state.DISTRICTS=items 
          }else if(value_item==='CONSTITUENCIES'||value_item==='CONSTITUENCY') {
            state.CONSTITUENCIES=items 
          }else if(value_item==='POLLING_STATIONS'||value_item==='POLLING_STATION') {
            state.POLLING_STATIONS=items 
          }else if(value_item==='REPORTS'||value_item==='REPORT') {
            state.REPORTS=items 
          }else if(value_item==='SMS'||value_item==='sms') {
            state.SMS=items 
          }else if(value_item==='REPORT_CATEGORIES'||value_item==='REPORT_CATEGORY') {
            state.REPORT_CATEGORIES=items 
          }else if(value_item==='POLLS'||value_item==='POLL') {
            state.POLLS=items 
          }else if(value_item==='NEWS'||value_item==='NEWS') {
            state.NEWS=items 
          }  
            
        } catch (error) {
          commit("ERROR",{
            error:{
              error:error,
              data:payload
            },
            from:'update_local_item',
            page:NAME, 
          })
        }
      },  
    },
}